<form [formGroup]="productForm"  enctype="multipart/form-data">
  <div class="max-w-4xl mx-auto bg-white p-6 rounded shadow">
    <h2 class="text-2xl font-bold mb-6">Add New Product</h2>

    <!-- Select Category -->
    <!--<div class="mb-6">
    <label class="block mb-1 font-semibold text-gray-700">Select Category</label>
    <select class="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            formControlName="category">
      <option value="" disabled selected>Select a category</option>
      <option *ngFor="let cat of categories" [value]="cat.id">
        {{ cat.name }}
      </option>
    </select>
  </div>-->

        <!--Hidden Controls-->
      <input type="hidden" formControlName="categoryId" />
    

      <!-- Product Name -->
      <div class="mb-4">
        <label class="block mb-1 font-semibold">Product Name</label>
        <input type="text"
               formControlName="name"
               class="w-full border rounded px-3 py-2"
               placeholder="Enter product name" />
      </div>


      <div class="mb-4">
        <label class="block mb-1 font-semibold">Description</label>
        <input type="text"
               formControlName="description"
               class="w-full border rounded px-3 py-2"
               placeholder="Enter product description" />
      </div>

      <div class="mb-4">
        <label class="block mb-1 font-semibold">Specification</label>
        <input type="text"
               formControlName="specification"
               class="w-full border rounded px-3 py-2"
               placeholder="Enter product description" />
      </div>

      <div class="mb-4">
        <label class="block mb-1 font-semibold">Price</label>
        <input type="number"
               formControlName="price"
               class="w-full border rounded px-3 py-2"
               placeholder="Enter product price" />
      </div>

      <div class="mb-4">
        <label>Image</label>
        <input type="file" (change)="onImageChange($event)" />
        <div *ngIf="previewUrl" class="mt-2">
          <img [src]="previewUrl" alt="Preview" class="h-24 rounded" />
        </div>
      </div>

      <!-- Select Sizes -->
      <div class="mb-6" [formGroup]="productForm">
        <label class="block mb-1 font-semibold">Select Sizes</label>
        <div class="flex flex-wrap gap-3">
          <label *ngFor="let entry of sizes" class="flex items-center space-x-2">
            <input type="checkbox"
                   [value]="entry.size"
                   (change)="onSizeChange($event, entry.size)"
                   class="form-checkbox text-blue-600" />
            <span>{{ entry.size }}</span>
          </label>
        </div>
      </div>

      <!-- Size Chart Table -->
      <!--<div formArrayName="sizeChart">
      <label class="block mb-1 font-semibold">Add Size Chart</label>
      <div *ngFor="let group of sizeChart.controls; let i = index" [formGroupName]="i" class="mb-4 border p-4 rounded">
        <div class="grid grid-cols-4 gap-4">
          <input type="text" formControlName="size" placeholder="Size" class="form-input" />
          <input type="number" formControlName="chest" placeholder="Chest" class="form-input" />
          <input type="number" formControlName="length" placeholder="Length" class="form-input" />
          <input type="number" formControlName="sleeve" placeholder="Sleeve" class="form-input" />
        </div>
        <button type="button" (click)="removeSizeChartEntry(i)" class="text-red-500 mt-2">Remove</button>
      </div>
    </div>-->

      <div class="mb-6" formArrayName="sizeChart">
        <h3 class="text-lg font-semibold mb-2">Size Chart</h3>
        <table class="min-w-full border text-sm">
          <thead>
            <tr class="bg-gray-100">
              <th class="border px-3 py-2">Size</th>
              <th class="border px-3 py-2">Chest (in)</th>
              <th class="border px-3 py-2">Length (in)</th>
              <th class="border px-3 py-2">Sleeve (in)</th>
              <th class="border px-3 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let group of sizeChart.controls; let i = index" [formGroupName]="i" class="mb-4 border p-4 rounded">
              <td class="border px-2 py-1">
                <input type="text" formControlName="size" placeholder="Size" class="form-input" />
              </td>
              <td class="border px-2 py-1">
                <input type="number" formControlName="chest" placeholder="Chest" class="form-input" />
              </td>
              <td class="border px-2 py-1">
                <input type="number" formControlName="length" placeholder="Length" class="form-input" />
              </td>
              <td class="border px-2 py-1">
                <input type="number" formControlName="sleeve" placeholder="Sleeve" class="form-input" />
              </td>
              <td class="border px-2 py-1 text-center">
                <button type="button" (click)="removeSizeChartEntry(i)" class="text-red-500 mt-2">Remove</button>
              </td>
            </tr>
          </tbody>
        </table>
        <button class="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                (click)="addSizeChartEntry()">
          + Add Row
        </button>
      </div>


      <!--<button type="button" (click)="addSizeChartEntry()" class="mt-4 bg-blue-500 text-white px-4 py-2 rounded">
      Add Size Chart Entry
    </button>-->
      <!-- Save Button -->
      <!--<div class="text-right">
      <button class="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
              (click)="saveProduct()">
        Save Product
      </button>
    </div>-->

      <button type="submit" (click)="saveProduct()"
              class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
        {{ isEditMode ? 'Update' : 'Add' }}
      </button>

  </div>
</form>
